
import "controllers";
import "stylesheets/application.scss";
import "utils/timezone_cookie";
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

Sentry.init({
    dsn: "https://e7cae43300234c36b84c6bfdcf20c2cb@o1036852.ingest.sentry.io/6089350"
});

import Rails from "@rails/ujs";
Rails.start();

import jQuery from "jquery";

require("@nathanvda/cocoon");
